<template>
    <div class="modal fade" id="order_reject_modal" tabindex="-1" role="dialog" aria-labelledby="complaintModal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="myModalLabel">Reject Order</h4>
                </div>
                <form class="form-horizontal" @submit.prevent="rejectOrder()">
                    <div class="modal-body">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-md-12">
                                    <label>
                                        Rejection Reason*
                                    </label>
                                    <div @click="reasonSelected(item.id)" class="form-check" v-for="(item, index) in cancelReasons" v-bind:key="index">
                                        <input class="form-check-input" type="radio" name="rejectionReason" :id="'rejectionReason' + item.id" value="option1" :checked="item.id === 1">
                                        <label class="form-check-label m-l-sm" :for="'rejectionReason' + item.id">
                                            {{ item.reason }}
                                        </label>
                                    </div>
                                    <textarea v-if="rejectReasonId === 4" v-model="reason" type="text" placeholder="Please specify" class="form-control" rows="3"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="submit" v-bind:disabled="saveButtonDisable" v-bind:class="'btn btn-danger ld-over ld-ext-right ' + submitBtlLoaderClass">Reject<i class="ld ld-ring ld-spin"></i></button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OrderRejectModal",
    data() {
        return {
            submitBtlLoaderClass: "",
            saveButtonDisable: false,
            rejectReasonId: 1,
            reason: null
        }
    },
    props: {
        order: {
            type: Object,
            required: true
        },
        cancelReasons: {
            type: Array,
            required: true
        }
    },
    methods: {
        async rejectOrder() {
            await this.$store.dispatch('stopNotificationBell');
            if(this.rejectReasonId !== 4 || (this.reason !== null && this.reason !== '')) {
                this.submitBtlLoaderClass = "running";
                this.saveButtonDisable = true
                const payload = new URLSearchParams({
                    order_id: this.order.id,
                    status_id: this.$status.CANCELED.id,
                    cancel_reason_id: this.rejectReasonId,
                    cancel_reasons: this.reason
                });
                if (this.rejectReasonId !== 4) {
                    payload.delete("cancel_reasons")
                }
                this.$emit('rejectOrder', payload)
                this.rejectReasonId = 1;
                this.reason = null;
                // eslint-disable-next-line no-undef
                $("#order_reject_modal").modal("hide");
                // eslint-disable-next-line no-undef
                $("#branch_order_view_model").modal("hide");
                this.saveButtonDisable = false;
                this.submitBtlLoaderClass = "";
            } else {
                alert("Please specify the reason of rejection");
            }
        },
        reasonSelected(id) {
            this.rejectReasonId = id
        }
    }
}
</script>

<style scoped>

</style>
